<template>
  <v-container
    grid-list-md
    align-center
    text-xs-center>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-card-title-text>
              <div>
                <h3>Notificações</h3>
              </div>
            </v-card-title-text>
            <v-spacer/>
            <v-card>
              <v-btn
                color="primary"
                dark
                @click="showModal = true">
                <v-icon>mdi-plus</v-icon>
                Adicionar
              </v-btn>
            </v-card>

          </v-card-title>
          <v-card>
            <v-data-table
              :headers="headers"
              :items="notificacoes"
              :search="search"
              :loading="loading"
              class="elevation-1">
              <template
                slot="items"
                slot-scope="props">
                <td>{{ props.item.id }}</td>
                <td>{{ props.item.titulo }}</td>
                <td>{{ props.item.mensagem }}</td>
                <td>{{ props.item.data }}</td>
                <td>
                  <v-btn
                    icon
                    small
                    @click="edit(props.item)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    small
                    @click="delete(props.item)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="showModal">
      <v-card>
        <v-card-title>
          <v-card-title-text>
            <h3>Adicionar Notificação</h3>
          </v-card-title-text>
          <v-spacer/>
          <v-btn
            color="error"
            dark
            @click="showModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="max-height: 440px; overflow:auto;">
          <v-container>
            <v-layout
              flex
              wrap>
              <v-flex xs12>
                <v-select
                  v-model="para"
                  :items="paraItems"
                  label="Para"
                  item-text="nome"
                  item-value="id"
                  multiple
                  chips
                  clearable
                  @change="paraChange"/>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="form.titulo"
                  :rules="[rules.required]"
                  label="Título"
                  required/>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="form.titulo_en"
                  label="Título inglês"/>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model="form.mensagem"
                  :rules="[rules.required]"
                  label="Mensagem"
                  required
                  outline/>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model="form.mensagem_en"
                  label="Mensagem inglês"
                  outline/>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.data"
                  :rules="[rules.required]"
                  label="Data"
                  type="date"
                  required/>
              </v-flex>

              <v-flex xs6>
                <v-text-field
                  v-model="form.horario"
                  :rules="[rules.required]"
                  label="Horario"
                  type="time"
                  required/>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="primary"
            dark
            @click="showModal = false">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            dark
            @click="save">
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
export default {
  data: () => ({
    showModal: false,
    form: {
      titulo: '',
      mensagem: '',
      data: '',
      horario: ''
    },
    headers: [{
      text: 'ID',
      align: 'left',
      value: 'id'
    }, {
      text: 'Título',
      align: 'left',
      value: 'titulo'
    }, {
      text: 'Mensagem',
      align: 'left',
      value: 'mensagem'
    }, {
      text: 'Data',
      align: 'left',
      value: 'data'
    }, {
      text: 'Ações',
      align: 'left',
      sortable: false
    }],
    notificacoes: [],
    loading: false,
    rules: {
      required: value => !!value || 'Obrigatório'
    }
  }),
  created () {
    this.getNotificacoes()
  },
  methods: {
    getNotificacoes () {
      this.axios.get('/api/notificacoes_adm').then(response => {
        this.notificacoes = response.data.data
      })
    }
  }
}
</script>
